import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';
import styled from 'styled-components';
import IconArrow from '../atoms/assets/icons/IconArrow';

const ButtonHolder = styled.div`
  display: flex;
  flex-direction: row-reverse;
  justify-content: space-between;
  align-content: center;
`

class HowDoesItWork extends Component {

  state = {
    redirect: false,
  };

  clickHandler = () => {
    this.setState( {
      redirect: true,
    } );
  };

  skipHandler = () => {
    this.setState( {
      redirect: 'skip',
    } );
  };

  render() {
    if ( this.state.redirect === 'skip' ) {
      return <Redirect push to="/participant-details"/>;
    } else if ( this.state.redirect ) {
      return <Redirect push to="/what-will-i-learn"/>;
    } else {
      return (
        <main>
          <h1>How does it work?</h1>

          <p>To train machine learning to build an avatar from a photo, we need a couple of things, namely photos of people and labels (annotations of those photos). Photos are the input for the ML system, and the correspondent avatar is the output. Labels are important as they explain to the machine what the photos are. The machine will learn about different types and shapes of eyes, noses and hair through those labels, converting them afterwards into their virtual components (output). When the machine learns from a diverse set of labeled photos it will be able to do this conversion at scale, that is, for any photo.</p>

          <p>For this exercise, we need you to assign labels to the features of the people in these photos.</p>

          <ButtonHolder>
          <button className="primary text button-icon" onClick={this.clickHandler}>Next<IconArrow /></button>
          <button className="skip text" onClick={this.skipHandler}>Skip</button>
          </ButtonHolder>
        </main>
      )
    }
  }
}

function mapStateToProps( state ) {
  return {
    avatar: state.avatar,
  };
}

export default connect( mapStateToProps )( HowDoesItWork ); 
